__turbopack_context__.v({
  "content": "teacher-calendar-shell-module__er2MFq__content",
  "fullscreen": "teacher-calendar-shell-module__er2MFq__fullscreen",
});
